<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content style="padding: 0">
  <div *ngIf="trustedUrl">

    <img class="exercise-image"
    [src]="trustedUrl"
    width="100%" height="360" frameborder="0" allowtransparency allowfullscreen seamless>
  </div>
</mat-dialog-content>
<mat-dialog-actions fxLayout="column" fxLayoutGap="8px">
  <div fxFlex="2" fxLayout="row" fxLayoutGap="16px">
    <div fxFlex style="vertical-align: bottom;" fxLayout="column">
        <mat-icon fxFlex="100%" (click)="loadImage(currentIndex - 1)" svgIcon="icon_left_arrow"></mat-icon>
    </div>
    <div style="vertical-align: top;" fxLayout="column">
        <p style="text-align: center; vertical-align: center; margin-bottom: 2em;" fxFlexFill>Image {{ currentIndex + 1 }} of {{ images.length }}</p>
    </div>    
    <div fxFlex style="vertical-align: bottom;" fxLayout="column">
        <mat-icon fxFlex="100%" (click)="loadImage(currentIndex + 1)" svgIcon="icon_right_arrow"></mat-icon>
    </div>    
  </div>
  <button fxFlex="1" mat-button mat-dialog-close fxFlex>Close</button>
</mat-dialog-actions>
